import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import styled, { useTheme } from "styled-components";
import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";

const StyledCard = styled.div`
  text-decoration: none;
  display: flex;
  height: 100%;
  padding: 1em;
  font-size: var(--fz-sm);
  border: var(--border-width-hard) solid ${({ theme }) => theme.colors.dborder};
  transform: translateZ(0);
  transition: all 0.4s ease;
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Poppins";
  font-weight: 400;
  color: ${({ theme }) => theme.colors.descfont};
  ${({ theme }) => theme.mixins.flex.flexCenter};

  @media (min-width: 400px) {
    font-size: var(--fz-md);
  }

  @media (min-width: 800px) {
    padding: 1.5em;
    h1 {
      font-size: var(--fz-xxl);
    }
  }

  :hover {
    border: var(--border-width-hard) solid
      ${({ theme }) => theme.colors.dborder};
  }
`;

const StyledImage = styled(GatsbyImage)`
  img {
    border-radius: 5px;
    margin: 0 auto;
  }
  width: 100%;
  height: 100%;
  max-width: 60px;
  max-height: 60px;

  @media (min-width: 400px) {
    max-width: 80px;
    max-height: 80px;
  }

  @media (min-width: 800px) {
    max-width: 100px;
    max-height: 100px;
  }
`;

const SquareCardWithIcon = ({
  darkImg,
  lightImg,
  cardLink,
  blank,
}: {
  darkImg: any;
  lightImg: any;
  cardLink: string;
  blank: boolean;
}) => {
  const { mode } = useTheme();
  if (!blank) {
    return (
      <Link to={cardLink}>
        <StyledCard>
          <StyledImage
            image={mode === "dark" ? darkImg : lightImg}
            alt="toolpooldark"
          />
        </StyledCard>
      </Link>
    );
  } else {
    return (
      <OutboundLink href={cardLink} target="_blank">
        <StyledCard>
          <StyledImage
            image={mode === "dark" ? darkImg : lightImg}
            alt="toolpooldark"
          />
        </StyledCard>
      </OutboundLink>
    );
  }
};

export default SquareCardWithIcon;
